import React, { useState, useEffect } from 'react';
import { getProject, loadProject } from '../Store/Project';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { getDash, setSort, setSortDirection, setStage } from '../Store/Dash';
import { ProjectCard } from '../Models/ProjectCard';
import { getRoadmap } from '../Store/Roadmap';
import { format } from 'date-fns';
import { handleLoadComponent } from '../Helpers/handleLoadComponent';
import { getSettings } from '../Store/Settings';
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { IconBase } from 'react-icons';
import { useIsMobile } from '../Core/hooks';

function RoadmapDashFunnel() {

    const dispatch = useAppDispatch();
    let dashState = useAppSelector(getDash);
    let projectState = useAppSelector(getProject);
    let roadmapState = useAppSelector(getRoadmap);
    let settingsState = useAppSelector(getSettings);
    let [sort, setLocalSort] = useState("date");
    let [sortDirection, setLocalSortDirection] = useState("desc");
    const isMobile = useIsMobile();

    useEffect(() => {
        setLocalSort(dashState.sort);
        setLocalSortDirection(dashState.sortDirection);
    },[]);

    const showDetail = (stage: string) => {
        dispatch(setStage(stage));
    }

    const handleLoadProject = (e: React.MouseEvent<HTMLDivElement>, id: string) => {
        e.preventDefault();
        /* If project is already loaded, just switch to project screen, else load the project first */
        let project = projectState.projects.find(p => p.loaded);
        if (project && project._id === id) {
            handleLoadComponent(dispatch, "work", settingsState.settings);
        } else {
            dispatch(loadProject(id));
        }
    }

    const handleSort = (field: string) => {
        if (field === sort) {
            setLocalSortDirection((sortDirection === "asc") ? "desc" : "asc");
            dispatch(setSortDirection((sortDirection === "asc") ? "desc" : "asc"));
        } else {
            setLocalSort(field);
            setSortDirection("desc");
            dispatch(setSortDirection("desc"));
        }
        dispatch(setSort(field));
    }

    let openColor = "#2e86c1";
    let inProgressColor = "#e67e22";
    let pausedColor = "#f4d03f";
    let doneColor = "#138d75";
    let canceledColor = "#2e4053";
    let strategyColor = "#9b59b6";
    let backgroundColor = "#fff";
    let headerColor = "#fff";
    
    let widthLeft = "40%";
    let widthRight = "60%";
    const WORK_FUNNEL = "workFunnel";
    let stage = dashState.stage;
    let cards: Array<ProjectCard> = dashState.allProjectCardsInRoadmap;
    
    if (dashState.selectedProjectId !== "") {
        cards = dashState.allProjectCardsInRoadmap.filter(card => {
            // find the list that this card belongs to
            const list = dashState.allProjectListsInRoadmap.find(list => list._id === card.listId);
            // include the card if the list belongs to the target project
            return list?.projectId === dashState.selectedProjectId;
        });
    }

    if (dashState.fromDate && dashState.toDate) {
        const from = new Date(dashState.fromDate);
        from.setHours(0, 0, 0, 0);
      
        const to = new Date(dashState.toDate);
        to.setHours(0, 0, 0, 0);
      
        cards = cards.filter(card => {
          const created = new Date(card.created);
          created.setHours(0, 0, 0, 0);
          const completed = new Date(card.statusChanged);
          completed.setHours(0, 0, 0, 0);
          if (card.status !== "Done"){
            return created >= from && created <= to;
          } else {
            return completed >= from && completed <= to;
          }
        });
      }

    let total = cards.length;
    
    let open = cards.filter(c => c.status === "Open");
    let inProgress = cards.filter(c => c.status === "In Progress");
    let paused = cards.filter(c => c.status === "Paused");
    let done = cards.filter(c => c.status === "Done");
    let canceled = cards.filter(c => c.status === "Canceled");
    let strategy = cards.filter(c => c.status === "Strategy");

    let funnelStagesPresent = 0;
    let funnelStageWidth = 96;
    let strategyWidth = "";
    let openWidth = "";
    let pausedWidth = "";
    let canceledWidth = "";
    let inProgressWidth = "";
    let doneWidth = "";

    if (strategy.length > 0) {
        strategyWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
        //funnelStageWidth -= 20;
        funnelStageWidth *= .8;
    }

    if (open.length > 0) {
        openWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
        //funnelStageWidth -= (funnelStagesPresent > 0) ? 16 : 20;
        funnelStageWidth *= .8;
    } 

    if (paused.length > 0) {
        pausedWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
       // funnelStageWidth -= (funnelStagesPresent > 1) ? 14 : 20;
       funnelStageWidth *= .8;
    } 

    if (canceled.length > 0) {
        canceledWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
        //funnelStageWidth -= (funnelStagesPresent > 2) ? 10 : 20;
        funnelStageWidth *= .8;
    } 

    if (inProgress.length > 0) {
        inProgressWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
        //funnelStageWidth -= (funnelStagesPresent > 2) ? 10 : 20;
        funnelStageWidth *= .8;
    } 

    if (done.length > 0) {
        doneWidth = funnelStageWidth + "%";
        funnelStagesPresent++;
    }

    let details: Array<JSX.Element> = [];
    let projectCards: Array<ProjectCard> = [];

    if (stage === "Open") {
        projectCards = open;
        backgroundColor = openColor;
    } else if (stage === "In Progress") {
        projectCards = inProgress;
        backgroundColor = inProgressColor;
    } else if (stage === "Paused") {
        projectCards = paused;
        headerColor = "#000";
        backgroundColor = pausedColor;
    } else if (stage === "Done") {
        projectCards = done;
        backgroundColor = doneColor;
    } else if (stage === "Canceled") {
        projectCards = canceled;
        backgroundColor = canceledColor;
    } else if (stage === "Strategy") {
        projectCards = strategy;
        backgroundColor = strategyColor;
    }

    let sortTitleIcon: any = (sort !== "title") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortProjectIcon: any = (sort !== "project") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortOwnerIcon: any = (sort !== "owner") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;
    let sortDateIcon: any = (sort !== "date") ? <TiArrowSortedUp /> : (sortDirection === "asc") ? <TiArrowSortedUp /> : <TiArrowSortedDown />;

    interface row {
        _id: string;
        title: string;
        project: string;
        owner: string;
        created: Date;
    }

    let rows: Array<row> = [];

    projectCards.forEach(card => {
        let list = dashState.allProjectListsInRoadmap.find(l => l._id === card.listId);
        if (list) {
            let project = projectState.projects.find(p => p._id === list!.projectId);
            if (project) {
                let member = roadmapState.members.find(m => m.userId === card.ownerId);
                //if (member) {
                    rows.push({
                        _id: project._id,
                        title: card.title,
                        project: project.name,
                        owner: (member) ? member.firstName + " " + member.lastName : "",
                        created: stage !== "Done" ? card.created : card.statusChanged
                    })
                //}
            }
        }
    })

    if (sort === "date") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
        } else {
            rows.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());
        }
    } else if (sort === "title") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.title.localeCompare(a.title));
        } else {
            rows.sort((a, b) => a.title.localeCompare(b.title));
        }
    } else if (sort === "project") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.project.localeCompare(a.project));
        } else {
            rows.sort((a, b) => a.project.localeCompare(b.project));
        }
    } else if (sort === "owner") {
        if (sortDirection === "desc") {
            rows.sort((a, b) => b.owner.localeCompare(a.owner));
        } else {
            rows.sort((a, b) => a.owner.localeCompare(b.owner));
        }
    }


/*
    if (sort === "title") {
    } else if(sort === "project") {

    } else if(sort === "owner") {
    } else if(sort === "date") {
    }
*/




    let row = 0;
    
    rows.forEach(card => {
        details.push(
            <div style={{ fontSize: "10pt", display: "flex", alignItems: isMobile ? "left" : "center",
                borderBottom: "1px solid #efefef", padding: "5px 0px"
                }}>
                <div style={{ width: isMobile ? "50%" : "25%" }}>
                    {card.title}
                </div>
                <div style={{ width: isMobile ? "50%" : "25%", cursor: "pointer" }} onClick={(e) => handleLoadProject(e, card._id)}>
                    <u>{card.project}</u>
                </div>
                {!isMobile &&
                <>
                    <div style={{ width: "25%" }}>
                        {card.owner}
                    </div>
                    <div style={{ width: "25%" }}>
                        {format(new Date(card.created), 'MMMM do')}
                    </div>
                </>
                }
            </div>
        );
        row++;
    });

    return (
        <div className="rightContentDefault"
        style={{
            ...(isMobile
            ? {
                padding: "15px 0px",
                overflowY: "auto"
              }
            : {
                padding: "15px 25px",
                overflowY: "auto"
            }),
        }}
        >
            <div style={{ textAlign: 'center' }}>
                <div
                style={{
                    ...(isMobile
                    ? {
                        width: "100%",
                      }
                    : {
                        width: widthLeft,
                        fontWeight: 500,
                        display: "inline-block"
                    }),
                }}>

                    <div style={{ width: "100%", backgroundColor: "#12354d", borderRadius: "30px",
                        color: "#fff", height: "22px", fontSize: "10pt", fontWeight: 400
                    }}>
                        {total} items
                    </div> 
                    {total > 0 ?
                    <>
                        {strategy.length > 0 &&
                            <div 
                                onClick={() => showDetail("Strategy")} 
                                style={{
                                margin: "5px auto 0px auto",
                                width: strategyWidth,
                                height: "75px",
                                backgroundColor: strategyColor,
                                clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>Strategy</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {strategy.length} 
                                    </div>
                                </div>
                            </div>
                        }
                        
                        {open.length > 0 &&
                            <div
                                onClick={() => showDetail("Open")}  
                                style={{
                                margin: "5px auto 0px auto",
                                width: openWidth,
                                height: "75px",
                                backgroundColor: openColor,
                                clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>Open</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {open.length}
                                    </div>
                                </div>
                            </div>
                        }

                        {paused.length > 0 &&
                            <div
                                onClick={() => showDetail("Paused")} 
                                style={{
                                margin: "5px auto 0px auto",
                                width: pausedWidth,
                                height: "75px",
                                backgroundColor: pausedColor,
                                clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#000",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>Paused</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {paused.length}
                                    </div>
                                </div>
                            </div>
                        }

                        {canceled.length > 0 &&
                            <div
                                onClick={() => showDetail("Canceled")} 
                                style={{
                                margin: "5px auto 0px auto",
                                width: canceledWidth,
                                height: "75px",
                                backgroundColor: canceledColor,
                                clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>Canceled</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {canceled.length}
                                    </div>
                                </div>
                            </div>
                        }

                        {inProgress.length > 0 &&
                            <div 
                            onClick={() => showDetail("In Progress")}
                            style={{
                                margin: "5px auto 0px auto",
                                width: inProgressWidth,
                                height: "75px",
                                backgroundColor: inProgressColor,
                                clipPath: "polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>In Progress</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {inProgress.length}
                                    </div>
                                </div>
                            </div>
                        }

                        {done.length > 0 &&
                            <div 
                            onClick={() => showDetail("Done")}
                            style={{
                                margin: "5px auto 0px auto",
                                width: doneWidth,
                                height: "75px",
                                backgroundColor: doneColor,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                cursor: "pointer"
                            }}>
                                <div style={{ textAlign: "center" }}>
                                    <div>Done</div>
                                    <div style={{ fontWeight: "bold", fontSize: "1.5em" }}>
                                        {done.length}
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                    :
                        <div style={{ fontStyle: "italic", fontSize: "10pt", marginTop: "10px" }}>No work items found</div>
                    }
                </div>

                <div 
                    style={{
                        ...(isMobile
                        ? {
                            width: "100%",
                          }
                        : {
                            width: widthRight,
                            margin: '0px auto', 
                            display: "inline-block",
                            verticalAlign: "top",
                            textAlign: "left",
                            paddingLeft: "20px"
                        }),
                    }}
                    >
                    {details.length > 0 ?
                        <>
                        <div
                            style={{
                                ...(isMobile
                                ? {
                                    fontSize: "11pt",
                                    fontWeight: 550,
                                    padding: "5px",
                                    backgroundColor: backgroundColor,
                                    borderRadius: "30px", 
                                    color: headerColor, 
                                    textAlign: "center",
                                    marginTop: "20px",
                                    width: "100%"
                                }
                                : {
                                    fontSize: "11pt",
                                    fontWeight: 550,
                                    padding: "5px",
                                    backgroundColor: backgroundColor,
                                    borderRadius: "30px", 
                                    color: headerColor, 
                                    textAlign: "center"
                                }),
                            }}>
                            {stage}
                        </div>
                        <div style={{ fontSize: "10pt", fontWeight: 550, padding: "5px 0px", borderBottom: "1px solid #efefef" }}>
                            <div style={{ display: "inline-block", width: isMobile ? "50%" : "25%" }}>
                                Title 
                                <span className="ps-2" style={{ cursor: "pointer" }} onClick={() => handleSort("title")}>
                                    {sortTitleIcon}
                                </span>
                            </div>
                            <div style={{ display: "inline-block", width: isMobile ? "50%" : "25%" }}>
                                Project
                                <span className="ps-2" style={{ cursor: "pointer" }} onClick={() => handleSort("project")}>
                                    {sortProjectIcon}
                                </span>
                            </div>
                            {!isMobile &&
                            <>
                                <div style={{ display: "inline-block",  width: "25%" }}>
                                    Owner
                                    <span className="ps-2" style={{ cursor: "pointer" }} onClick={() => handleSort("owner")}>
                                        {sortOwnerIcon}
                                    </span>
                                </div>
                                <div style={{ display: "inline-block", width: "25%" }}>
                                    {(stage !== "Done") ? "Created" : "Completed"}
                                    <span className="ps-2" style={{ cursor: "pointer" }} onClick={() => handleSort("date")}>
                                        {sortDateIcon}
                                    </span>
                                </div>
                            </>
                            }
                        </div>
                        <div style={{ height: 'calc(100vh - 200px)', overflowY: "auto" }}>
                            {details}
                        </div>
                        </>
                    :
                        <>
                        {!isMobile &&
                            <div style={{ fontStyle: "italic", marginTop: "150px", textAlign: "center" }}>
                                Click a stage to see the work items
                            </div>
                        }
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default RoadmapDashFunnel;
